import { render } from "./citizenModal.vue?vue&type=template&id=12ea6fe5&scoped=true&ts=true"
import script from "./citizenModal.vue?vue&type=script&lang=ts"
export * from "./citizenModal.vue?vue&type=script&lang=ts"

import "./citizenModal.vue?vue&type=style&index=0&id=12ea6fe5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ea6fe5"]])

export default __exports__